import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { reduxForm, Field } from 'redux-form';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Toolbar from '@material-ui/core/Toolbar';

import IconButton from 'components/common/IconButton';
import IconFilter from 'components/icons/IconFilter';
import Button from 'components/common/Button';
import Link from 'components/common/Link';
import CheckboxButtonField from 'components/fields/CheckboxButtonField';
import IconArchive from 'components/icons/IconArchive';
import PageTitle from 'components/common/PageTitle';

const styles = theme => ({
  root: {
    marginBottom: 15,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 8,
    },
  },
  link: {
    color: theme.palette.grey[600],
    marginRight: 40,
    [theme.breakpoints.down('sm')]: {
      marginRight: 16,
    },
  },
  iconArchive: {
    width: 20,
    height: 20,
    margin: '-4px 4px 0 0',
    verticalAlign: 'middle',
  },
  gridItemCategories: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexWrap: 'nowrap',
      maxWidth: '100%',
      flexBasis: '100%',
      overflowX: 'auto',
    },
  },
  gridItemActions: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  buttonFilter: {
    display: 'none',
    marginLeft: -10,
    marginBottom: -14,
    marginTop: -16,
    [theme.breakpoints.down('sm')]: {
      display: 'block',
    },
  },
  buttonFilterActive: {
    color: theme.palette.primary[500],
  },
  iconFilter: {
    width: 16,
    height: 16,
  },
});

const NavigationFilter = ({ variant, theme, classes, archive, onMobileFilterBottonClick, filters }) => (
  <form
    noValidate
    autoComplete="off"
  >
    <Toolbar
      className={classes.root}
      disableGutters
    >
      <Grid
        container
        justify="space-between"
        alignItems="center"
        spacing={24}
      >
        {archive &&
          <Grid item>
            <PageTitle
              text="Archive"
              href="/workflow"
              variant="button"
            />
          </Grid>
        }
        <Grid className={classes.gridItemCategories} item>
          <Field
            id="Intake"
            name="Intake"
            label="Intake"
            color={archive ? theme.palette.states.archive : theme.palette.states.intake}
            component={CheckboxButtonField}
          />
          <Field
            id="Delivery"
            name="Delivery"
            label="Delivery"
            color={archive ? theme.palette.states.archive : theme.palette.states.delivery}
            component={CheckboxButtonField}
          />
          <Field
            id="Billing"
            name="Billing"
            label="Billing"
            color={archive ? theme.palette.states.archive : theme.palette.states.billing}
            component={CheckboxButtonField}
          />
          <Field
            id="Collection"
            name="Collection"
            label="Collection"
            color={archive ? theme.palette.states.archive : theme.palette.states.collection}
            component={CheckboxButtonField}
          />
          <Field
            id="Paid"
            name="Paid"
            label="Paid"
            color={archive ? theme.palette.states.archive : theme.palette.states.paid}
            component={CheckboxButtonField}
          />
          <Field
            id="Rejected"
            name="Rejected"
            label="Rejected"
            color={archive ? theme.palette.states.archive : theme.palette.states.rejected}
            component={CheckboxButtonField}
          />
        </Grid>
        {!archive &&
          <Grid className={classes.gridItemActions} item>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              wrap="nowrap"
              spacing={0}
            >
              <Grid className={classes.gridItemMobileFilterBotton} item>
              <IconButton
                onClick={onMobileFilterBottonClick}
                className={classNames(classes.buttonFilter, {
                  [classes.buttonFilterActive]: filters && Object.keys(filters).length > 0,
                })}
              >
                <IconFilter className={classes.iconFilter} />
              </IconButton>
              </Grid>
              <Grid item>
                <Link
                  className={classes.link}
                  href="/workflow/archive"
                  size="md"
                  bold
                >
                  <IconArchive className={classes.iconArchive} />
                  Archive
                </Link>
                <Button
                  variant="raised"
                  color="primary"
                  href="/workflow/order/create/patient-assign"
                  target="_blank"
                >
                  Add New Order
                </Button>
              </Grid>
            </Grid>
          </Grid>
        }
      </Grid>
    </Toolbar>
  </form>
);

NavigationFilter.propTypes = {
  variant: PropTypes.oneOf(['workflow', 'delivery-schedule']),
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      states: PropTypes.shape({
        intake: PropTypes.string.isRequired,
        delivery: PropTypes.string.isRequired,
        billing: PropTypes.string.isRequired,
        collection: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    link: PropTypes.string.isRequired,
    iconArchive: PropTypes.string.isRequired,
  }).isRequired,
};

NavigationFilter.defaultProps = {
  variant: 'workflow',
};

export default reduxForm()(withStyles(styles, { withTheme: true })(NavigationFilter));



// WEBPACK FOOTER //
// ./src/components/workflow/NavigationFilter/NavigationFilter.js